import { h } from "preact";
import css from "./style.scss";
import cx from "classnames";

const Tooltip = ({ children, text, header }) => {
  return (
    <div tabindex="1" class={cx(css.wrapper)}>
      <span class={cx(css.item)}>{children}</span>
      <div class={cx(css.tooltip)}>
        {header && <div class={cx(css.header)}>{header}</div>}
        <div class={cx(css.text)}>{text}</div>
      </div>
    </div>
  );
};
export default Tooltip;
